enum PaymentRemittancesDataType {
  FILLED = 'FILLED',
  EMPTY = 'EMPTY',
}

export default PaymentRemittancesDataType;
